import React from 'react';
import { prop } from 'ramda';

import { Divider } from 'js/app/components/common/Divider/Divider';

import { useUserSelector } from 'js/store/hooks';
import { highlightText } from 'js/app/utils/common.util';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import style from './PortletTitle.scss';

export const PortletTitle = ({ portlet, configuration = {} }) => {
    const role = useUserSelector(prop('role'));
    const { title = '', showTitle, customCSSClassName = '' } = portlet;

    const isDivider = customCSSClassName?.includes('isDivider');
    const [mainTitle, subTitle] = title.split('|');

    const content = (
        <div
            className={
                clsx(
                    style.wrap,
                    customCSSClassName,
                    { [style.isCenter]: configuration.isCenter }
                )
            }
        >
            <h1
                style={{ color: configuration.color }}
                dangerouslySetInnerHTML={{ __html: highlightText(mainTitle) }}
                className={
                    clsx(
                        style.title,
                        { [style.isCustomStyle]: configuration.isCustomStyle }
                    )
                }
            />
            {subTitle && <div className={style.subTitle}>{subTitle}</div>}
            {isDivider && <Divider />}
        </div>
    );

    if (!showTitle || !title) {
        if (role === 'admin') {
            return content;
        }
        return null;
    }

    return content;
};
